import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_15lckq7jwd: FaireBrandEntity = {
  token: "b_15lckq7jwd",
  type: "brand",
  name: "Tibetan Socks",
  avatarUrl:
    "https://cdn.faire.com/fastly/9b3905dce136b809f085477a3eebac3fb2f9e4365b3b54c49532fd16fc7eb20f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/815c773b6fa5a69d99ed384c5e025c0ff1d22747b6c864f6ed789a6476a78a91.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9b3905dce136b809f085477a3eebac3fb2f9e4365b3b54c49532fd16fc7eb20f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/815c773b6fa5a69d99ed384c5e025c0ff1d22747b6c864f6ed789a6476a78a91.jpeg",
  location: "Port Orange, FL, USA",
  minimumOrderDollars: 600,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Tibetan Socks began with a simple, personal need: warmth that truly lasts. While traveling through the Himalayas over a decade ago, our founder discovered hand-knit wool socks crafted by local artisans—pieces that offered a level of comfort and insulation unlike anything found back home. Living with Raynaud’s, he understood immediately: this wasn’t just a product, it was a solution.\n\nWhat started with a suitcase of 20 pairs has grown into a globally recognized brand, built on craftsmanship, purpose, and enduring design. Each pair of Tibetan Socks is still made by hand, using premium wool and traditional techniques passed down through generations. The result is a product that doesn’t just keep you warm—it molds to your feet over time, becoming uniquely yours.\n\nAt the heart of the brand is a commitment to the artisans who make it possible. We proudly support a network of over 200 women across Himalayan communities, providing flexible, home-based work that preserves heritage skills while creating sustainable income.\n\nTibetan Socks is more than a cozy essential—it’s a connection between worlds. From the mountains where each pair is made to the homes where they are worn, every stitch carries a story of craftsmanship, resilience, and care.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:12.221Z",
    importedBy: "entity-db-cli",
  },
};
